export default __webpack_public_path__ + "static/media/loader.669e4000.svg";